import React, {useState, useEffect, useRef} from 'react';
import './style.scss';
import useToggle from '../../hooks/Toggle/useToggle';
import Icon from '../../components/Icon/Icon';

const Collapsible = (props) => {
    const [isToggled, toggle] = useToggle(false);
    const refInner = useRef();
    const refPanel = useRef();
    const [drawerHeight, setDrawerHeight] = useState(0);
    const [btnDisabled, setBtnDisabled] = useState(null);

    const title = props.title;
    const theImg = props.theImg;
    const children = props.children;
    

    useEffect(() => {
        if(isToggled){
            setDrawerHeight(refInner.current.clientHeight)
            refPanel.current.scrollIntoView()
            props.handleToggleFade(true)
            return
        }
        setDrawerHeight(0)
        props.handleToggleFade(false)
        
    },[isToggled, props]);

    useEffect((isToggled) => {
        if(props.fadeLayer && isToggled){
            setBtnDisabled(true)
        }else{
            setBtnDisabled(false)
        }
    },[props.fadeLayer])

    return (
        <div className={`panel ${isToggled ? 'is-expanded' : ''}`} >

            <div className={`panel-heading ${btnDisabled && 'disabled'}`} onClick={toggle} ref={refPanel} >
                <div className={`fade-layer ${props.fadeLayer ? 'fade-on' : ''}`}></div>
                <img src={theImg} alt="" />
                <h2>{title}<Icon type="plus-inverted" /></h2>
            </div>

            <div className="panel-collapse" style={{height: drawerHeight +'px'}} >
                <div className="panel-body" ref={refInner}>
                    {children}
                    <button className="close-drawer" onClick={toggle}><Icon type="plus-inverted" /></button>
                </div>
            </div>

        </div>

    )
}
export default Collapsible;